import { FC, useRef, useState } from "react";
import { CreateUserForm } from "../../organisms/CreateUserForm";
import { Wrapper, HeaderText, Header, FormWrapper, LeftSideWrapper, BackIcon, RightSideWrapper } from "./elements";
import back from "../../../assets/icons/back.svg";
import { Button } from "../../atoms/Button";
import { FormikProps } from "formik";
import { AddNewUserType } from "../../organisms/CreateUserForm/CreateUserForm";

type Props = {
  onBack?: () => void;
  onCreateUser: (values: AddNewUserType) => void;
  isLoading?: boolean;
  isSuperAdmin?: boolean;
};

const CreateUser: FC<Props> = ({ onBack, onCreateUser, isLoading, isSuperAdmin }) => {
  const formRef = useRef<FormikProps<any>>(null);
  const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const [isAccountActive, setIsAccountActive] = useState(false);

  const onHandleSubmit = () => {
    if (formRef.current) {
      formRef.current?.setFieldValue('accountStatus', isAccountActive ? 'active' : 'suspended');
      formRef.current?.handleSubmit();
    }
  }
  const handleSwitchStatus = () => {
    setPopConfirmVisible(true);
  }

  const onConfirm = () => {
    setPopConfirmVisible(false);
    setIsAccountActive(!isAccountActive);
  }
  
  const onCancel = () => {
    setPopConfirmVisible(false);
  }

  return (
    <>
    <Wrapper>
      <Header>
        <LeftSideWrapper>
          <BackIcon src={back} onClick={onBack} />
          <div>
            <HeaderText>Create User</HeaderText>
          </div>
        </LeftSideWrapper>
        <RightSideWrapper>
          <Button type="primary" disabled={isLoading} onClick={onHandleSubmit}>Save</Button>      
        </RightSideWrapper>
      </Header>
      <FormWrapper>
        <CreateUserForm 
          isAccountActive={isAccountActive}
          handleSwitchStatus={handleSwitchStatus} 
          onConfirm={onConfirm} 
          onCancel={onCancel} 
          popConfirmVisible={popConfirmVisible} 
          innerRef={formRef}
          onCreateUser={onCreateUser}
          isSuperAdmin={isSuperAdmin}
        />
      </FormWrapper>
    </Wrapper>
    </>
  )
}

export default CreateUser;
